import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 12h6m3 0h1.5m3 0h.5","key":"svg-0"}],["path",{"d":"M5 12l6 6","key":"svg-1"}],["path",{"d":"M5 12l6 -6","key":"svg-2"}]]

/**
 * IconArrowLeftDashed
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctbGVmdC1kYXNoZWQiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTUgMTJoNm0zIDBoMS41bTMgMGguNSIgLz4KICA8cGF0aCBkPSJNNSAxMmw2IDYiIC8+CiAgPHBhdGggZD0iTTUgMTJsNiAtNiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/arrow-left-dashed
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowLeftDashed = createReactComponent('outline', 'arrow-left-dashed', 'ArrowLeftDashed', __iconNode);

export default IconArrowLeftDashed;